import { OverflowMenuHorizontal } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

import { InboundDeliveryAction } from "../../../models/autogenerated-deliveryService-gql/graphql";
import IconButtonWithPopover from "../../buttons/IconButtonWithPopover/IconButtonWithPopover";
import DeliveryActionsList from "../../deliveryActions/deliveryActionsList/DeliveryActionsList";

interface ActionsButtonWithPopoverProps {
  actions: InboundDeliveryAction[];
  deliveryId: string;
}

const ActionsButtonWithPopover = (props: ActionsButtonWithPopoverProps) => {
  const { t } = useTranslation();
  const { actions, deliveryId } = props;

  return (
    <IconButtonWithPopover
      title={t("yourDelivery")}
      buttonIcon={<OverflowMenuHorizontal size={24} />}
    >
      <DeliveryActionsList actions={actions} deliveryId={deliveryId} />
    </IconButtonWithPopover>
  );
};
export default ActionsButtonWithPopover;
